import { render } from "./userLogin.vue?vue&type=template&id=9f8a52f2&scoped=true"
import script from "./userLogin.vue?vue&type=script&lang=js"
export * from "./userLogin.vue?vue&type=script&lang=js"

import "./userLogin.vue?vue&type=style&index=0&id=9f8a52f2&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8a52f2"]])

export default __exports__